import BillItem from './styles'

export default BillItem